// Global WordPress pages cache
export const wpCache = {};

export default wpCache;